import { useCallback } from 'react';
import { useVerification } from '../../VerificationPopup/withVerification';
import { useRestrictToLoggedIn } from './useRestrictToLoggedIn';
import noop from '../noop';
/** returns whether current user:
 *    - is logged in
 *    - has verfified their email
 *  and a function that will:
 *    - send the user to the join page if they're logged out
 *    - open the verification popup if they haven't verified
 *    - call the given callback if logged in and verified
 */ export function useRestrictToLoggedInAndVerified() {
    const { isLoggedIn, sendUserToJoinPage } = useRestrictToLoggedIn();
    const { isVerificationNeeded, pushVerificationPopup } = useVerification();
    const restrictToLoggedInAndVerified = useCallback((restrictedActionName, actionType, callback = noop)=>(ev)=>{
            if (!isLoggedIn) {
                (ev === null || ev === void 0 ? void 0 : ev.preventDefault) && ev.preventDefault();
                return sendUserToJoinPage(restrictedActionName);
            }
            if (isVerificationNeeded) {
                (ev === null || ev === void 0 ? void 0 : ev.preventDefault) && ev.preventDefault();
                return pushVerificationPopup(actionType);
            }
            return callback();
        }, [
        isLoggedIn,
        sendUserToJoinPage,
        isVerificationNeeded,
        pushVerificationPopup
    ]);
    return {
        isLoggedIn,
        isVerificationNeeded,
        restrictToLoggedInAndVerified
    };
}
